<template>
    <!--コンテンツ-->
    <main id="renew2_top">
        <div class="renew2_top">
            <div class="mv" v-if="$site.appFlag != 'b'">
                <ul class="renew2_flex renew2_sp_flex mv_txtblock" v-if="!$deviceLib.isMobileDevice">
                    <li class="mv__txt">
                        <p><span class="mv__green">회원가입</span><span class="mv__small">으로</span><br>백업<br>기능</p>
                    </li>
                    <li class="mv__txt">
                        <p><span class="mv__green">무료</span><span class="mv__small">로</span>이력서<br>간단입력</p>
                    </li>
                    <li class="mv__txt renew2_pc">
                        <p><span class="mv__small">야기슈에서</span><br><span class="mv__green">제출까지</span><br>간단히</p>
                    </li>
                </ul>
                <div class="mv__toggle renew2_sp">
                    <h3>무료이력서 <span>다운로드</span></h3>
                </div>
            </div>

            <div class="format" style="margin-top:5px;">
                <p v-if="!$deviceLib.isMobileDevice || $site.appFlag == 'b'" class="renew2_wrapper">이력서 양식을 무료로 다운로드 하세요
                </p>
                <div class="format_block">
                    <div class="renew2_wrapper">
                        <div id="rirekisyo_format" class="rirekisyo"
                            v-if="!(selectedKind == '送付状' || selectedKind == '職務経歴書')">
                            <div class="renew2_flex renew2_sp_flex format_block__list01">
                                <h3>이력서</h3>
                            </div>
                            <div class="format_block__list02 renew2_flex renew2_sp_flex">
                                <a :href="'#'" @click="dlFun(f.dl, f.title, f.type)" :key="f.id"
                                    v-for="f in forSearchHashs" class="format_item">
                                    <div class="format_img">
                                        <img :src="f.thumbnail" :alt="f.title + '템플릿'">
                                        <!-- <img src="/kr/resume/static/renew2_img/rirekisho_job_change.png" :alt="f.title + 'テンプレート'"> -->
                                    </div>
                                    <div class="format_txt">
                                        <div class="renew2_flex renew2_sp_flex memo">
                                            <p>{{ f.type }}</p>
                                        </div>
                                        <h3 class="h3">{{ f.title }}</h3>
                                    </div>
                                    <button class="format_btn">이력서다운</button>
                                </a>

                                <!--                                <span-->
                                <!--                                   v-for="f in forSearchHashs"-->
                                <!--                                   class="format_item">-->
                                <!--                                    <div class="format_txt">-->
                                <!--                                        <div class="renew2_flex renew2_sp_flex memo">-->
                                <!--                                            <p>{{ f.type }}</p>-->
                                <!--                                        </div>-->
                                <!--                                        <h3 class="h3">{{ f.title }}</h3>-->

                                <!--                                    </div>-->
                                <!--                                    <button class="format_btn"  @click="dlFun(f.dl,f.title,f.type)">이력서다운</button>-->
                                <!--                                </span>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
const saveBtn = (url) => {

}
</script>
<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_top.css"></style>

<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
export default {
    components: {
        'blog-widget': blogWidget,
        'yagi-omikuji': YagiOmikuji,
        Slick
    },
    data: function () {
        return {
            is_not_midnight: true,
            recentEdit: {
                FormatId: ''
            },
            isWhat: true,
            isWho: false,
            selectedKind: '',
            selectedHash: '',
            mvBanner:1,
            slickOptions:{
                centerMode: true,
                // centerPadding: '-20px',
                variableWidth: false,
                accessibility: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 4000,
                asNavFor: '.slider-nav',
                speed: 400
            },
            slickNavOptions:{
                focusOnSelect: true,
                asNavFor: '.slider-for',
                variableWidth: false,
                slidesToShow: 5,
                centerPadding: '20px',
            }
        }
    },
    methods: {
        dlFun: function(url,name,type) {

            // 저장하고자하는 파일명
            const filename = name+"."+type;
            const element = document.createElement('a');
            element.setAttribute('href',  encodeURIComponent(url));
            element.setAttribute('download', filename);
            document.body.appendChild(element);
            element.click();
        },
        searchHash: function(_hash) {
            this.selectedHash = _hash
        },
        searchKind: function(_kind) {
            this.selectedKind = _kind
        },
        reload: function () {
            location.reload(true)
        },
        recentEditClass: function (format) {
            if (!this.recentEdit) return
            if (this.recentEdit.FormatId === format.id) {
                return {
                    'current-edit': true
                }
            }
        },
        loadRecentEdit: function () {
            const app = this
            this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
                if (err) {
                    console.log(err)
                }
                if (data) {
                    app.recentEdit = data
                }
            })
        },
        updateRecentEdit: function (data) {
            if (data) {
                this.recentEdit = data
            }
        },

    },
    computed: {
        forSearchHashs:function() {
            let _rtVal = []
            if (this.selectedHash) {
                for (let obj of this.$site.dlIndex) {
                    for (let _hash of obj.hashs) {
                        if (_hash == this.selectedHash) {
                            _rtVal.push(obj)
                        }
                    }
                }
                return _rtVal
            } else {
                return this.$site.dlIndex
            }
        }
    },
    created: function () {
        // console.error(this.$deviceLib.getUserAgent.substring(0, 190))
        this.loadRecentEdit()
        const now = new Date()
        if (now.getHours() >= 0 && now.getHours() < 6) {
            this.is_not_midnight = false
        }
        this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
        this.$eventHub.$on('reload', this.reload)
    },
    destroyed: function () {
        this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
        this.$eventHub.$off('reload', this.reload)
    }
}
</script>
